import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';

export class PowerPanelDto extends InspectionCase {
  item_9_1?: InspectionCase;
  item_9_2?: InspectionCase;
  item_9_3?: InspectionCase;
  item_9_4?: InspectionCase;
  item_9_5?: InspectionCase;
  item_9_6?: InspectionCase;
  item_9_7?: InspectionCase;
  item_9_8?: InspectionCase;
}

export class PowerPanel extends PowerPanelDto {
  constructor(data: PowerPanelDto = { title: 'לוחות חשמל' }) {
    super(data);
    this.item_9_1 = new InspectionCase({
      ...data.item_9_1,
      title: `בכל אתר שמותקנת מערכת גילוי עשן , מותקנים גלאי עשן בלוחות חשמל מ 63A ומעלה תלת פאזי , ובלוחות חשמל 200A ומעלה בזרם ישר (למעט לוחות של חברת חשמל)`
    });
    this.item_9_2 = new InspectionCase({
      ...data.item_9_2,
      title: `הותקנו מנורות סימון לגלאים המותקנים בלוחות החשמל. במידה ולוח חשמל הותקן בתוך הפיר, יש להוציא מנורות סימון מחוץ לפיר`
    });
    this.item_9_3 = new InspectionCase({
      ...data.item_9_3,
      title: `
      בדרגת סיכון 1 ניתן לבצע ניתוק של כלל מערכות החשמל שבמבנה.
בכל המבנים (רמת 1 ו- 2) , לא נותקו מערכות חיוניות , לרבות משאבות כיבוי אש , מעליות  , מערכות על לחץ ומדפי עשן ומפוחים.
(לא חל על מקומות מאוישים 24 שעות ביממה וקיים מפסק לניתוק החשמל ידני במקום נגיש וידוע  או במתקנים חיוניים בהתאם להנחיית כיבוי אש או יועץ הבטיחות
      `
    });
    this.item_9_4 = new InspectionCase({
      ...data.item_9_4,
      title: `בארונות חשמל או חדרי חשמל עד למתח של 6 קילו וולט , מותקן גלאי מסוג יניקה`
    });
    this.item_9_5 = new InspectionCase({
      ...data.item_9_5,
      title: `ניתן להסתפק במערכת יניקה אחת בלוח חשמל "רב תאי " עם נורית סימון אחת`
    });
    this.item_9_6 = new InspectionCase({
      ...data.item_9_6,
      title: `בארונות חשמל עם זרימת אוויר מאולצת במהירות מעל 0.76 מטר לשנייה ליד הגלאי, יותקן גלאי יניקה`
    });
    this.item_9_7 = new InspectionCase({
      ...data.item_9_7,
      title: `התקנת גלאי בארון חשמל, תיעשה כך שפתחי כניסת העשן של הגלאי יהיו בתוך חלל הארון ושתהיה אפשרות לבצע תחזוקה לגלאי מחוץ ללוח לארון ומבלי לפתוח את הארון`
    });
    this.item_9_8 = new InspectionCase({
      ...data.item_9_8,
      title: 'בוצע ניתוק חשמל מלוח מזין'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_9_1.isApplicable || this.item_9_1.isPassed) &&
        (!this.item_9_2.isApplicable || this.item_9_2.isPassed) &&
        (!this.item_9_3.isApplicable || this.item_9_3.isPassed) &&
        (!this.item_9_4.isApplicable || this.item_9_4.isPassed) &&
        (!this.item_9_5.isApplicable || this.item_9_5.isPassed) &&
        (!this.item_9_6.isApplicable || this.item_9_6.isPassed) &&
        (!this.item_9_7.isApplicable || this.item_9_7.isPassed) &&
        (!this.item_9_8.isApplicable || this.item_9_8.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_9_1.getNotes(),
      ...this.item_9_2.getNotes(),
      ...this.item_9_3.getNotes(),
      ...this.item_9_4.getNotes(),
      ...this.item_9_5.getNotes(),
      ...this.item_9_6.getNotes(),
      ...this.item_9_7.getNotes(),
      ...this.item_9_8.getNotes()
    ];
  }

  getMultiNotes?(): SummaryNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_9_1.getMultiNotes(),
      ...this.item_9_2.getMultiNotes(),
      ...this.item_9_3.getMultiNotes(),
      ...this.item_9_4.getMultiNotes(),
      ...this.item_9_5.getMultiNotes(),
      ...this.item_9_6.getMultiNotes(),
      ...this.item_9_7.getMultiNotes(),
      ...this.item_9_8.getMultiNotes()
    ];
  }
}
